import React from 'react';
import { Moment } from "moment";
import styled from "styled-components";
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import { useTranslation } from "react-i18next";
import DateFlicker, { DateScale } from '@shared/ui/molecules/DateFlicker';
import { DownloadHighLevelHolidayReportButton } from "./DownloadHighLevelHolidayReportButton";
import { DownloadDetailedHolidayReportButton } from "./DownloadDetailedHolidayReportButton";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "@shared/store/auth.duck";
import { isOfficeAdminUser } from "@shared/utils/AccessControl";
import { tablet } from '@shared/ui/atoms/MediaQueries';

export function DownloadHolidayReport(props: Props) {
  const {selectedDate} = props;
  const {t} = useTranslation();
  const user = useSelector(selectCurrentUser);
  const canAccessReport = isOfficeAdminUser(user);

  return (
    <>
      <Wrapper>
        <HeadlineSmall style={{marginBottom: 8}}>{t('reports-page.download-holiday-summary')}</HeadlineSmall>
        <Row>
          <DateFlicker className={'dateFlicker'} dateScale={DateScale.Year} updateGlobalDate={false} onChange={date => props.setDate(date)} />
          <DownloadHighLevelHolidayReportButton selectedDate={selectedDate} disabled={canAccessReport} />
          <DownloadDetailedHolidayReportButton selectedDate={selectedDate} disabled={canAccessReport} />
        </Row>
      </Wrapper>
    </>
  )
}

interface Props {
  selectedDate: Moment;
  selectedTeamId?: string;
  setDate: (date: Moment) => void;
}

const Wrapper = styled.div`
  margin: 36px 0 24px 0;
`

const Row = styled.div`
  display: flex;
  flex-direction: column;
  p {
    margin-right: 24px;
    padding-right: 24px;
  }
  button {
    max-width: 100%;
    margin-bottom: 12px;
  }
  .dateFlicker {
    width: 100%;
    max-width: 400px;
    margin-bottom: 12px;
  }
  @media (${tablet}) {
    flex-direction: row;
    align-items: center;
    .dateFlicker {
      max-width: 300px;
      margin-bottom: 0;
    }
    button {
      margin-bottom: 0;
      margin-left: 32px;
      max-width: 192px;
    }
  }
`
